<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Health Education Sessions</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Manage health education sessions" name="description" />
    <meta content="CBHI System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Health Education</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">HEW</a></li>
                    <li class="breadcrumb-item active">Health Education</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Alerts -->
          <div v-if="alert.success" class="alert alert-success" role="alert">
            {{message}}
          </div>
          <div v-if="alert.info" class="alert alert-primary" role="alert">
            {{message}}
          </div>
          <div v-if="alert.failed" class="alert alert-danger" role="alert">
            {{message}}
          </div>

          <!-- Statistics Cards -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Sessions This Month</p>
                      <h5 class="mb-0">{{ statistics.sessions_month || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-chalkboard"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Attendees</p>
                      <h5 class="mb-0">{{ statistics.attendees_month || 0 }}</h5>
                      <p class="text-muted mb-0 mt-1">
                        <small>Avg: {{ statistics.avg_attendees || 0 }}/session</small>
                      </p>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-group"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Topics Covered</p>
                      <h5 class="mb-0">{{ statistics.topics_covered || 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-book-open"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Hours Delivered</p>
                      <h5 class="mb-0">{{ Math.round(statistics.total_hours || 0) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="bx bx-time"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Popular Topics Chart -->
          <div class="row">
            <div class="col-lg-8">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Popular Education Topics</h5>
                </div>
                <div class="card-body">
                  <div v-if="topicStats.length > 0">
                    <div v-for="topic in topicStats" :key="topic.topic" class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>{{ topic.topic }}</span>
                        <span class="text-muted">{{ topic.sessions }} sessions ({{ topic.attendees }} attendees)</span>
                      </div>
                      <div class="progress" style="height: 10px;">
                        <div class="progress-bar" role="progressbar"
                             :style="{width: getTopicPercentage(topic) + '%'}"
                             :class="getTopicColor(topic.category)">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-center py-4">
                    <p class="text-muted">No topic statistics available</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-4">
              <div class="card">
                <div class="card-header bg-white">
                  <h5 class="mb-0">Session Types</h5>
                </div>
                <div class="card-body">
                  <div class="d-flex justify-content-around text-center">
                    <div>
                      <h3 class="mb-2 text-primary">{{ statistics.individual_sessions || 0 }}</h3>
                      <p class="text-muted mb-0">Individual</p>
                    </div>
                    <div>
                      <h3 class="mb-2 text-success">{{ statistics.group_sessions || 0 }}</h3>
                      <p class="text-muted mb-0">Group</p>
                    </div>
                    <div>
                      <h3 class="mb-2 text-warning">{{ statistics.community_sessions || 0 }}</h3>
                      <p class="text-muted mb-0">Community</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center w-100 border-bottom-1 pb-3 border-bottom">
                  <!-- Filters -->
                  <div class="me-3 text-nowrap filter-tool-bar-btns">
                    <!-- Session Type Filter -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-light waves-effect" data-bs-toggle="dropdown">
                        <i class="bx bx-filter font-size-16 me-1 align-middle"></i>
                        {{ getFilterLabel() }}
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="filterSessions('all')">All Sessions</a>
                        <a class="dropdown-item" @click="filterSessions('individual')">Individual</a>
                        <a class="dropdown-item" @click="filterSessions('group')">Group</a>
                        <a class="dropdown-item" @click="filterSessions('community')">Community</a>
                      </div>
                    </div>

                    <!-- Topic Category Filter -->
                    <div class="btn-group ms-2">
                      <button type="button" class="btn btn-light waves-effect" data-bs-toggle="dropdown">
                        <i class="bx bx-category font-size-16 me-1 align-middle"></i>
                        {{ getCategoryLabel() }}
                      </button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="filterByCategory('')">All Categories</a>
                        <a class="dropdown-item" @click="filterByCategory('maternal_health')">Maternal Health</a>
                        <a class="dropdown-item" @click="filterByCategory('child_health')">Child Health</a>
                        <a class="dropdown-item" @click="filterByCategory('nutrition')">Nutrition</a>
                        <a class="dropdown-item" @click="filterByCategory('hygiene_sanitation')">Hygiene & Sanitation</a>
                        <a class="dropdown-item" @click="filterByCategory('disease_prevention')">Disease Prevention</a>
                        <a class="dropdown-item" @click="filterByCategory('family_planning')">Family Planning</a>
                      </div>
                    </div>

                    <!-- Date Range -->
                    <div class="btn-group ms-2">
                      <button type="button" class="btn btn-light waves-effect" data-bs-toggle="dropdown">
                        <i class="bx bx-calendar font-size-16 me-1 align-middle"></i> Date Range
                      </button>
                      <div class="dropdown-menu p-4" style="width: 300px;">
                        <div class="row">
                          <div class="col-12 mb-2">
                            <label class="form-label">Start Date</label>
                            <input v-model="dateRange.start" type="date" class="form-control">
                          </div>
                          <div class="col-12 mb-2">
                            <label class="form-label">End Date</label>
                            <input v-model="dateRange.end" type="date" class="form-control">
                          </div>
                          <div class="col-12 mt-2">
                            <button @click="applyDateFilter" type="button" class="btn btn-primary w-100">Apply</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Clear Filters -->
                    <button v-if="hasActiveFilters" type="button" class="btn btn-danger waves-effect ms-2"
                            @click="clearFilters">
                      <i class="bx bx-x font-size-16 me-1 align-middle"></i> Clear
                    </button>
                  </div>

                  <div class="btn-toolbar d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input v-model="searchQuery" @keyup.enter="searchSessions" type="text"
                                 class="form-control bg-light border-light rounded"
                                 placeholder="Search by topic, venue, or household...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex gap-2">

                      <!-- Record New Session -->
                      <button @click="showRecordModal = true" type="button" class="btn btn-primary">
                        <i class="bx bx-plus"></i> <span class="d-md-inline ms-1">Record Session</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3">Loading sessions...</p>
                  </div>

                  <!-- No Data State -->
                  <div v-else-if="!loading && sessions.length === 0" class="text-center py-5">
                    <i class="bx bx-chalkboard text-muted" style="font-size: 48px;"></i>
                    <p class="mt-3 text-muted">No education sessions found</p>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover border table-striped text-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">Date & Time</th>
                        <th scope="col">Topic</th>
                        <th scope="col">Type & Venue</th>
                        <th scope="col">Target Audience</th>
                        <th scope="col">Attendance</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Materials</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="session in sessions" :key="session.session_id">
                        <td>
                          <div>
                            <h6 class="mb-0">{{ formatDate(session.session_date) }}</h6>
                            <small class="text-muted">{{ formatTime(session.session_date) }}</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <h6 class="mb-0">{{ session.topic }}</h6>
                            <span :class="'badge ' + getCategoryBadge(session.topic_category)">
                              {{ formatCategory(session.topic_category) }}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span :class="'badge ' + getTypeBadge(session.session_type) + ' mb-1'">
                              {{ session.session_type }}
                            </span>
                            <div class="text-muted small">
                              <i class="bx bx-map"></i> {{ session.venue || 'Not specified' }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            {{ session.target_audience || 'General' }}
                            <div v-if="session.household_number" class="text-muted small">
                              HH: {{ session.household_number }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div class="d-flex align-items-center">
                              <i class="bx bx-group text-primary me-1"></i>
                              <strong>{{ session.attendees_count }}</strong>
                            </div>
                            <div class="text-muted small">
                              <span class="text-info">♂ {{ session.male_attendees }}</span> |
                              <span class="text-danger">♀ {{ session.female_attendees }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-light text-dark">
                            <i class="bx bx-time-five"></i> {{ session.duration_minutes }} min
                          </span>
                        </td>
                        <td>
                          <div>
                            <span v-if="session.materials_used" class="text-success"
                                  :title="session.materials_used">
                              <i class="bx bx-check-circle"></i> Used
                            </span>
                            <span v-else class="text-muted">-</span>
                            <div v-if="session.demonstration_done" class="text-primary small">
                              <i class="bx bx-show"></i> Demo
                            </div>
                          </div>
                        </td>
                        <td class="text-center">
                          <div class="btn-group" role="group">
                            <button @click="viewSession(session)" class="btn btn-sm btn-primary"
                                    title="View Details">
                              <i class="bx bx-show"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_info">
                        Showing {{ (currentPage - 1) * limit + 1 }} to {{ Math.min(currentPage * limit, total) }} of {{ total }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{'disabled': currentPage === 1}">
                            <a @click="changePage(currentPage - 1)" href="#" class="page-link">Previous</a>
                          </li>
                          <li v-for="page in displayedPages" :key="page" class="paginate_button page-item"
                              :class="{'active': page === currentPage}">
                            <a @click="changePage(page)" href="#" class="page-link">{{ page }}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{'disabled': currentPage === totalPages}">
                            <a @click="changePage(currentPage + 1)" href="#" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Import Modal Components -->
      <RecordEducationModal
          v-if="showRecordModal"
          :session="selectedSession"
          @close="showRecordModal = false"
          @recorded="onSessionRecorded"
      />

      <SessionDetailsModal
          v-if="showDetailsModal"
          :session="selectedSession"
          @close="showDetailsModal = false"
      />


      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import RecordEducationModal from "@/components/hew/modals/RecordEducationModal.vue";
import SessionDetailsModal from "@/components/hew/modals/SessionDetailsModal.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "HealthEducation",
  components: {
    NavigationBar,
    RecordEducationModal,
    SessionDetailsModal,
  },
  data() {
    return {
      // Loading states
      loading: false,

      // Data
      sessions: [],
      selectedSession: null,
      statistics: {},
      topicStats: [],

      // Filters
      sessionType: 'all',
      topicCategory: '',
      dateRange: {
        start: '',
        end: ''
      },
      searchQuery: '',

      // Pagination
      currentPage: 1,
      limit: 20,
      total: 0,

      // UI States
      showRecordModal: false,
      showDetailsModal: false,
      showMaterialsModal: false,

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },

    displayedPages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    hasActiveFilters() {
      return this.sessionType !== 'all' ||
          this.topicCategory !== '' ||
          this.dateRange.start !== '' ||
          this.dateRange.end !== '';
    }
  },

  mounted() {

    this.loadSessions();
    this.loadStatistics();
  },

  methods: {
    checkAuth() {
      const token = localStorage.getItem("authToken");
      const userRole = sessionStorage.getItem("userRoleId");

      if (!token) {
        router.push('/login');
        return;
      }

      // Check if user is HEW (role_id = 38)
      if (userRole !== '38') {
        this.showAlert('failed', 'Access denied. HEW role required.');
        router.push('/dashboard');
      }
    },

    async loadSessions() {
      this.loading = true;

      const data = {
        "function": "getHealthEducationSessions",
        "sessionType": this.sessionType === 'all' ? '' : this.sessionType,
        "topicCategory": this.topicCategory,
        "startDate": this.dateRange.start,
        "endDate": this.dateRange.end,
        "searchTerm": this.searchQuery,
        "limit": this.limit,
        "offset": (this.currentPage - 1) * this.limit
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.sessions = res.data.data.sessions || [];
          this.total = res.data.data.total || 0;
        } else {
          this.showAlert('failed', res.data.message || 'Failed to load sessions');
        }
      } catch (e) {
        console.error("Failed to load sessions:", e);
        this.showAlert('failed', 'Failed to load education sessions');
      } finally {
        this.loading = false;
      }
    },

    async loadStatistics() {
      const data = {
        "function": "getEducationStatistics",
        "period": "month"
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.statistics = res.data.data.statistics || {};
          this.topicStats = res.data.data.topicStats || [];
          this.calculateSessionTypes();
        }
      } catch (e) {
        console.error("Failed to load statistics:", e);
      }
    },

    calculateSessionTypes() {
      // Calculate session type counts from loaded sessions
      const types = {
        individual_sessions: 0,
        group_sessions: 0,
        community_sessions: 0
      };

      this.sessions.forEach(session => {
        if (session.session_type === 'individual') types.individual_sessions++;
        else if (session.session_type === 'group') types.group_sessions++;
        else if (session.session_type === 'community') types.community_sessions++;
      });

      this.statistics = { ...this.statistics, ...types };
    },

    filterSessions(type) {
      this.sessionType = type;
      this.currentPage = 1;
      this.loadSessions();
    },

    filterByCategory(category) {
      this.topicCategory = category;
      this.currentPage = 1;
      this.loadSessions();
    },

    applyDateFilter() {
      this.currentPage = 1;
      this.loadSessions();
    },

    clearFilters() {
      this.sessionType = 'all';
      this.topicCategory = '';
      this.dateRange = { start: '', end: '' };
      this.searchQuery = '';
      this.currentPage = 1;
      this.loadSessions();
    },

    async searchSessions() {
      this.currentPage = 1;
      await this.loadSessions();
    },

    async changePage(page) {
      if (page < 1 || page > this.totalPages) return;

      this.currentPage = page;
      await this.loadSessions();
    },

    viewSession(session) {
      this.selectedSession = session;
      this.showDetailsModal = true;
    },

    editSession(session) {
      this.selectedSession = session;
      this.showRecordModal = true;
    },

    duplicateSession(session) {
      // Create a copy without the ID
      const duplicate = { ...session };
      delete duplicate.session_id;
      duplicate.session_date = new Date().toISOString();

      this.selectedSession = duplicate;
      this.showRecordModal = true;
    },

    onSessionRecorded() {
      this.showRecordModal = false;
      this.selectedSession = null;
      this.showAlert('success', 'Education session recorded successfully');
      this.loadSessions();
      this.loadStatistics();
    },

    // Utility methods
    getFilterLabel() {
      const labels = {
        'all': 'All Sessions',
        'individual': 'Individual',
        'group': 'Group',
        'community': 'Community'
      };
      return labels[this.sessionType] || 'All Sessions';
    },

    getCategoryLabel() {
      const labels = {
        '': 'All Categories',
        'maternal_health': 'Maternal Health',
        'child_health': 'Child Health',
        'nutrition': 'Nutrition',
        'hygiene_sanitation': 'Hygiene & Sanitation',
        'disease_prevention': 'Disease Prevention',
        'family_planning': 'Family Planning'
      };
      return labels[this.topicCategory] || 'All Categories';
    },

    formatCategory(category) {
      return this.getCategoryLabel()[category] || category;
    },

    getCategoryBadge(category) {
      const badges = {
        'maternal_health': 'badge-soft-danger',
        'child_health': 'badge-soft-primary',
        'nutrition': 'badge-soft-success',
        'hygiene_sanitation': 'badge-soft-info',
        'disease_prevention': 'badge-soft-warning',
        'family_planning': 'badge-soft-secondary'
      };
      return badges[category] || 'badge-soft-secondary';
    },

    getTypeBadge(type) {
      const badges = {
        'individual': 'bg-primary',
        'group': 'bg-success',
        'community': 'bg-warning'
      };
      return badges[type] || 'bg-secondary';
    },

    getTopicPercentage(topic) {
      const maxAttendees = Math.max(...this.topicStats.map(t => t.attendees));
      return maxAttendees > 0 ? (topic.attendees / maxAttendees) * 100 : 0;
    },

    getTopicColor(category) {
      const colors = {
        'maternal_health': 'bg-danger',
        'child_health': 'bg-primary',
        'nutrition': 'bg-success',
        'hygiene_sanitation': 'bg-info',
        'disease_prevention': 'bg-warning',
        'family_planning': 'bg-secondary'
      };
      return colors[category] || 'bg-primary';
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    formatTime(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    // Alert methods
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    }
  }
};
</script>

<style scoped>
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #999;
}

.progress {
  background-color: #e9ecef;
}

.filter-tool-bar-btns .btn-group {
  margin-right: 5px;
}

.badge-soft-danger {
  color: #f46a6a;
  background-color: rgba(244, 106, 106, 0.18);
}

.badge-soft-warning {
  color: #f1b44c;
  background-color: rgba(241, 180, 76, 0.18);
}

.badge-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
}

.badge-soft-success {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}

.badge-soft-info {
  color: #50a5f1;
  background-color: rgba(80, 165, 241, 0.18);
}

.badge-soft-secondary {
  color: #74788d;
  background-color: rgba(116, 120, 141, 0.18);
}
</style>